import React, { useState } from "react";
import "./ButtonSelect.css";
import { Add20 } from "@carbon/icons-react";

function ButtonSelect(props) {
    const [value, setValue] = useState("");
    const [isNewFolder, setIsNewFolder] = useState(false);
    const [enteredFolderName, setEnteredFolderName] = useState("");
    const [statusMessage, setStatusMessage] = useState("");

    const user_Subscription = props.user_Subscription;

    function onChangeValue(e) {
        setValue(e.target.value);
        console.log(e.target.value);
        setIsNewFolder(false);
    }

    function onFolderNameChange(e) {
        // setStatus("");
        setEnteredFolderName(e.target.value);
        // console.log(e.target.value);
    }

    function onNewFolderClick(e) {
        e.preventDefault();
        setIsNewFolder(true);
    }
    return (
        <div>
            <div className="button-select-container">
                {user_Subscription.edges.map((edge, key) =>
                    edge.node.parent ? null : (
                        <div className="button-select-btn" key={edge.node.id}>
                            <label htmlFor={"btn" + edge.node.id}>
                                <input
                                    onChange={onChangeValue}
                                    name="folder"
                                    type="radio"
                                    id={"btn" + edge.node.id}
                                    value={edge.node.id}
                                />
                                <span>{edge.node.name}</span>
                            </label>
                        </div>
                    )
                )}

                <span
                    onClick={onNewFolderClick}
                    className="add-folder-button-container"
                >
                    <Add20 className="folder-add-icon" />
                    <span className="add-folder-button">NEW FOLDER</span>
                </span>
            </div>

            {isNewFolder ? (
                <div className="new-folder-input-container">
                    <label>Name</label>
                    <input
                        onChange={onFolderNameChange}
                        className="standard-textfield-small"
                        type="text"
                    />
                </div>
            ) : null}
        </div>
    );
}

export default ButtonSelect;
